import { InjectionToken } from '@angular/core';

export const FLOATING_POPUP_DATA = new InjectionToken<object | unknown>('FLOATING_POPUP_DATA');
